import React from 'react';
import { get, orderBy } from 'lodash';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import PlanCard from '../../components/PlanCard';

const styles = css`
  padding: 45px 0;
  @media (min-width: 992px) {
    padding: 90px 0;
  }
`;

function PlansResults({ plans, sort }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row justify-content-center">
          {
            orderBy(plans, sort.field, get(sort, 'dir', 'asc')).map(plan => (
              <div className="col-md-6 col-lg-4" key={plan._id}>
                <PlanCard plan={plan} />
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

PlansResults.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
  sort: PropTypes.object.isRequired,
};

export default withData(
  {
    plans: true,
  },
)(PlansResults);



// WEBPACK FOOTER //
// ./src/pages/Plans/PlansResults.js